module.exports = __webpack_public_path__ + "img/Diagram1.ee717003.svg";